<div [ngClass]="classSize" class="icon-container" [class.disable]="isIconDisabled"  [class.invert-color]="invertColor" (click)="clickOnIcon.emit()" (selectstart)="$event.preventDefault()"  (mousedown)="$event.preventDefault()">
  <svg [icon]="iconName" class="impaired-size-32 icon"></svg>
</div>
